import React from 'react';
import ModuleHeader from './ModuleHeader';

const moduleMeta = {
    'Prayer Calendar': { eyebrow: 'Build a rhythm', tone: 'sand' },
    'Prayer Journal': { eyebrow: 'Write it down', tone: 'ink' },
    'Prayer Requests': { eyebrow: 'Hold them close', tone: 'berry' },
    'Prayer Resources': { eyebrow: 'Keep learning', tone: 'moss' },
    'Settings': { eyebrow: 'Make it yours', tone: 'plum' },
    'Admin Operations': { eyebrow: 'Private diagnostics', tone: 'night' },
    'Prayer Timer': { eyebrow: 'Create stillness', tone: 'night' },
    'Prayer Garden': { eyebrow: 'See your growth', tone: 'garden' }
};

const ScreenLayout = ({ children, title, icon, eyebrow, tone, actions, className = '' }) => {
    const meta = moduleMeta[title] || {};
    return (
        <div className={`shared-module-shell shared-module-${tone || meta.tone || 'plum'} detail-screen ${className}`}>
            <ModuleHeader
                title={title}
                eyebrow={eyebrow || meta.eyebrow || 'Prayer Guide'}
                icon={icon}
                tone={tone || meta.tone || 'plum'}
                actions={actions}
            />
            <main className="shared-module-main">{children}</main>
        </div>
    );
};

export default ScreenLayout;
